<!-- eslint-disable max-len -->
<template>
  <v-select
    v-model='value'
    @selected=setValue
    label="name"
    :options="schema.values"
  />
</template>

<script>
import { abstractField } from 'vue-form-generator';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  mixins: [abstractField],
  components: {
    VSelect,
  },
  methods: {
    setValue(value) {
      this.value = value;
    },
  },
  props: {
    model: {
      type: Object,
    },
    schema: {
      type: Object,
    },
  },
};
</script>
